import React from 'react';
import { ShieldCheck, ArrowRight, Lock } from 'lucide-react';
export function PricingCTA() {
  const handleAddToCart = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'El Arca de Efectivo',
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
  };
  return <section id="pricing" className="py-20 lg:py-32 bg-navy text-center relative overflow-hidden" data-id="element-86">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold opacity-5 rounded-full blur-3xl pointer-events-none" data-id="element-87"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10 max-w-3xl" data-id="element-88">
        <div className="mb-10" data-id="element-89">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-90">
            Tu paz mental no tiene precio.
          </h2>
          <p className="text-xl text-cream-dark leading-relaxed mb-4" data-id="element-91">
            Tu paz mental para los próximos 10 años cuesta menos que una pizza
            familiar. No estás comprando un libro, estás comprando la seguridad
            de que, pase lo que pase mañana,{' '}
            <strong className="text-gold" data-id="element-92">tú tienes el control.</strong>
          </p>
        </div>

        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl border-4 border-gold/20 transform hover:scale-[1.02] transition-transform duration-300" data-id="element-93">
          <div className="mb-6" data-id="element-94">
            <h3 className="text-2xl font-bold text-navy mb-2" data-id="element-95">
              El Arca de Efectivo
            </h3>
            <p className="text-gray-500" data-id="element-96">
              Manual + Protocolo 3-2-1 + Hojas de Ruta
            </p>
          </div>

          <div className="inline-block bg-red-500 text-white text-sm font-bold px-4 py-1.5 rounded-full mb-4" data-id="element-97">
            🔥 86% DE DESCUENTO
          </div>
          <div className="flex justify-center items-baseline gap-2 mb-8" data-id="element-98">
            <span className="text-gray-400 line-through text-2xl" data-id="element-99">$47</span>
            <span className="text-6xl font-bold text-navy" data-id="element-100">$6.39</span>
            <span className="text-gray-500 font-medium" data-id="element-101">USD</span>
          </div>

          <a id="pricing-action" href="https://www.novantumnexus.com/cart/53920770720019:1" target="_blank" rel="noopener noreferrer" onClick={handleAddToCart} className="w-full py-5 px-8 bg-gold hover:bg-gold-light text-navy-dark font-bold rounded-xl transition-all duration-300 flex items-center justify-center gap-3 animate-pulse-gold shadow-lg shadow-gold/30 mb-6 text-[18px] no-underline" data-id="element-102">
            QUIERO CONSTRUIR MI ARCA ¡AHORA!
            <ArrowRight size={24} data-id="element-103" />
          </a>

          <div className="flex flex-col items-center gap-3 text-sm text-gray-500" data-id="element-104">
            <div className="flex items-center gap-2" data-id="element-105">
              <Lock size={16} className="text-green-600" data-id="element-106" />
              <span data-id="element-107">Pago 100% seguro y encriptado</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-108">
              <ShieldCheck size={16} className="text-green-600" data-id="element-109" />
              <span data-id="element-110">Entrega inmediata en tu correo tras la compra</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}